import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addToWishlistRequest = { items: '_wishlistItem' };
var _addToWishlistResponse = {};
var _getWishlistByIdRequest = {};
var _getWishlistByIdResponse = { wishlist: '_wishlistData' };
var _getWishlistRequest = {};
var _getWishlistResponse = { wishlist: '_wishlistData' };
var _getWishlistsRequest = {};
var _getWishlistsResponse = { wishlists: '_wishlistData' };
var _removeFromWishlistRequest = { items: '_wishlistItem' };
var _removeFromWishlistResponse = {};
var _wishlistData = { items: '_wishlistItem' };
var _wishlistItem = { dateAdded: 'google.protobuf.Timestamp' };
function resolveComWixpressWishlistWishlistUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/wishlist-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/wishlist-server',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wishlist-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/wishlist-server',
                destPath: '',
            },
        ],
        'ecom._base_domain_': [
            {
                srcPath: '/_api/wishlist-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wishlist-server',
                destPath: '/api',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wishlist-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores/v1/wishlists',
                destPath: '/v1/wishlists',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wishlist-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get default wishlist by context's member and site */
export function getWishlist(payload) {
    var _a = serializer(_getWishlistRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWishlistResponse, {
        _wishlistData: _wishlistData,
        _wishlistItem: _wishlistItem,
    }).fromJSON;
    function __getWishlist(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.platform.v1.wishlist',
            method: 'POST',
            methodFqn: 'com.wixpress.wishlist.Wishlist.GetWishlist',
            url: resolveComWixpressWishlistWishlistUrl({
                protoPath: '/v1/wishlists/my/get',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWishlist.fromReq = fromReq;
    __getWishlist.__isAmbassador = true;
    return __getWishlist;
}
/** Add items to default wishlist by context's member and site */
export function addToWishlist(payload) {
    var _a = serializer(_addToWishlistRequest, { _wishlistItem: _wishlistItem }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addToWishlistResponse, {}).fromJSON;
    function __addToWishlist(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.platform.v1.wishlist',
            method: 'POST',
            methodFqn: 'com.wixpress.wishlist.Wishlist.AddToWishlist',
            url: resolveComWixpressWishlistWishlistUrl({
                protoPath: '/v1/wishlists/my',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addToWishlist.fromReq = fromReq;
    __addToWishlist.__isAmbassador = true;
    return __addToWishlist;
}
/** Remove items to default wishlist by context's member and site */
export function removeFromWishlist(payload) {
    var _a = serializer(_removeFromWishlistRequest, { _wishlistItem: _wishlistItem }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeFromWishlistResponse, {}).fromJSON;
    function __removeFromWishlist(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.platform.v1.wishlist',
            method: 'POST',
            methodFqn: 'com.wixpress.wishlist.Wishlist.RemoveFromWishlist',
            url: resolveComWixpressWishlistWishlistUrl({
                protoPath: '/v1/wishlists/my/removeItems',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeFromWishlist.fromReq = fromReq;
    __removeFromWishlist.__isAmbassador = true;
    return __removeFromWishlist;
}
/** Get wishlist by id */
export function getWishlistById(payload) {
    var _a = serializer(_getWishlistByIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWishlistByIdResponse, {
        _wishlistData: _wishlistData,
        _wishlistItem: _wishlistItem,
    }).fromJSON;
    function __getWishlistById(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.platform.v1.wishlist',
            method: 'POST',
            methodFqn: 'com.wixpress.wishlist.Wishlist.GetWishlistById',
            url: resolveComWixpressWishlistWishlistUrl({
                protoPath: '/v1/wishlists/get',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWishlistById.fromReq = fromReq;
    __getWishlistById.__isAmbassador = true;
    return __getWishlistById;
}
/** Get wishlists of site */
export function getWishlists(payload) {
    var _a = serializer(_getWishlistsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWishlistsResponse, {
        _wishlistData: _wishlistData,
        _wishlistItem: _wishlistItem,
    }).fromJSON;
    function __getWishlists(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.platform.v1.wishlist',
            method: 'GET',
            methodFqn: 'com.wixpress.wishlist.Wishlist.GetWishlists',
            url: resolveComWixpressWishlistWishlistUrl({
                protoPath: '/v1/wishlists',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWishlists.fromReq = fromReq;
    __getWishlists.__isAmbassador = true;
    return __getWishlists;
}
//# sourceMappingURL=http.impl.js.map